import React, { useRef, useState } from 'react';
import { Form, Input, Button, Typography, message, theme } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import ReCAPTCHAComponent, { ReCAPTCHAComponentRef } from '@/components/ReCAPTCHA';

const { Title, Text } = Typography;

const ForgotPassword: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const recaptchaRef = useRef<ReCAPTCHAComponentRef>(null);
  const { token } = theme.useToken();

  const onFinish = async (values: { email: string }) => {
    if (!captchaToken) {
      message.warning('Por favor, complete o captcha.');
      return;
    }
    setLoading(true);
    try {
      // TODO: Implementar chamada à API
      console.log('Send reset email to:', values.email, 'captcha:', captchaToken);
      setSent(true);
      message.success('E-mail de recuperação enviado!');
    } catch (error) {
      message.error('Erro ao enviar e-mail. Tente novamente.');
      recaptchaRef.current?.reset();
      setCaptchaToken(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: token.colorBgLayout,
    }}>
      <div style={{
        background: token.colorBgContainer,
        padding: 40,
        borderRadius: 12,
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        width: '100%',
        maxWidth: 400,
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <Title level={3} style={{ margin: 0 }}>Esqueceu a senha?</Title>
          <Text type="secondary">Insira seu e-mail para recuperar</Text>
        </div>

        {sent ? (
          <div style={{ textAlign: 'center' }}>
            <Text>
              Um e-mail com as instruções de recuperação foi enviado para o seu endereço de e-mail.
            </Text>
            <div style={{ marginTop: 24 }}>
              <Link to="/login">Voltar para o login</Link>
            </div>
          </div>
        ) : (
          <Form
            name="forgot-password"
            onFinish={onFinish}
            layout="vertical"
            size="large"
          >
            <Form.Item
              name="email"
              rules={[
                { required: true, message: 'Por favor, insira seu e-mail' },
                { type: 'email', message: 'E-mail inválido' },
              ]}
            >
              <Input prefix={<MailOutlined />} placeholder="E-mail" />
            </Form.Item>

            <Form.Item>
              <ReCAPTCHAComponent
                ref={recaptchaRef}
                onChange={(value) => setCaptchaToken(value)}
              />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading} block>
                Enviar Link de Recuperação
              </Button>
            </Form.Item>

            <div style={{ textAlign: 'center' }}>
              <Link to="/login">Voltar para o login</Link>
            </div>
          </Form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;